import React, { useState } from 'react';
import api from '../lib/api';
import { X } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { toast } from 'sonner';


function AddColumnModal({ boardId, onClose, onColumnAdded }) {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Column name is required');
      return;
    }

    setLoading(true);
    try {
      const response = await api.post(
        `/columns`,
        { board_id: boardId, name: name.trim() },
        
      );
      toast.success('Column added successfully');
      onColumnAdded(response.data);
    } catch (error) {
      console.error('Failed to add column:', error);
      toast.error('Failed to add column');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="bg-white rounded-2xl shadow-xl max-w-md w-full border border-stone-200" data-testid="add-column-modal">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-stone-200">
          <h2 className="text-xl font-bold text-stone-900">Add New Column</h2>
          <button
            onClick={onClose}
            data-testid="close-add-column-modal"
            className="p-2 hover:bg-stone-100 rounded-xl transition-colors"
          >
            <X className="w-5 h-5 text-stone-500" strokeWidth={1.5} />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="mb-6">
            <label className="block text-sm font-medium text-stone-700 mb-2">
              Column Name
            </label>
            <Input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Testing"
              data-testid="column-name-input"
              className="w-full rounded-xl"
              autoFocus
            />
          </div>

          <div className="flex justify-end gap-3">
            <Button
              type="button"
              onClick={onClose}
              variant="outline"
              data-testid="cancel-add-column"
              className="bg-white border border-stone-200 hover:bg-stone-50 text-stone-700 rounded-xl"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={loading}
              data-testid="submit-add-column"
              className="bg-primary hover:bg-primary-hover text-stone-900 rounded-xl shadow-gold font-semibold"
            >
              {loading ? 'Adding...' : 'Add Column'}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddColumnModal;
